import React from 'react';
import KycContainer from '../KYCContainer/KYC';
import AddressProof from '../../../components/Dashboard-res/AddressProof/AddressProof';
export default function NewAddressProof() {
  const data = {
    pan: 'PENDING',
    address: 'NOT_INITIATED',
    selfie: 'NOT_INITIATED',
    bank: 'NOT_INITIATED',
    ref: 'NOT_INITIATED',
    custom: false
  };
  const current_page = {
    pan: false,
    address: true,
    selfie: false,
    bank: false,
    ref: false
  };
  return (
    <div>
      <KycContainer
        // guideName="Aadhaar Card"
        data={data}
        showAddress
        curr_page={current_page}
        // componentHandler={this.props.componentHandler}
        container={AddressProof}
        // onclick_handler={this.onclick_handler}
        // OnSubmit={this.OnSubmit}
      />
    </div>
  );
}
